import React from 'react';
import BlockText from './BlockText';
import BlockTextSettings from './Settings/BlockTextSettings';

/**
 * Return an array with the opts (option buttons when hovering) to show for this block.
 *
 * @param {useModal} modal 				        The useModal instance used to open and show this block's settings.
 * @param {function} changed 				    The function used to notify Builder when this block changes.
 * @param {function} removeBlock			    A function used to notify Builder to remove this block.
 * @param {useFormValidation} formValidation 	The useFormValidation instance used to validate this modals settings inputs.
 */
export const generateOpts = (
	openModal,
	closeModal,
	changed,
	removeBlock,
	formValidation
) => {
	return [
		{
			icon: ['fal', 'gear'],
			action: (blockData) => {
				const modalActions = [
					{
						text: 'Avbryt',
						isDefault: true,
						action: (originalState, currentState, closeModal) => {
							// Reset builder block settings
							changed(blockData);
							closeModal();
						}
					},
					{
						text: 'Klar',
						action: (originalState, currentState, closeModal) => {
							// Notify builder to update all block's atributes before closing the modal
							changed(currentState);
							closeModal();
						}
					}
				];

				openModal({
					title: 'Redigerar textblock',
					actions: modalActions,
					position: 'right',
					hideBackdrop: true,
					isPositionable: true,
					state: blockData
				});
			}
		},
		{
			icon: ['fal', 'trash'],
			action: (data) => {
				// Tell the builder to remove the block
				removeBlock(data);
				closeModal();
			}
		}
	];
};

export default {
	baseStruct: {
		key: null,
		data: {
			contents: '<p></p>',
			//contents: [{ type: 'paragraph', children: [{ text: '' }] }],
			type: 'text',
			partially_hidden: false
		}
	},
	builder: {
		component: <BlockText />,
		setOpts: generateOpts
	},
	settings: {
		component: <BlockTextSettings />
	}
};
